import { keepPreviousData } from "@tanstack/react-query";
import { createApiWikifolioTradeHistoryUrl } from "src/constants/urls";
import { IQueryOptions } from "src/lib/tanstack-query/hooks/use-query";
import { useQuery } from "src/lib/tanstack-query/hooks/use-query";
import { ITradeHistoryResponse } from "./trade-history.api.types";
import { tradeKeys } from "./trade.query-keys";

const PAGE_SIZE = 10;

export const useTradeHistoryTableQuery = (wikifolioId: string, page: number, options: IQueryOptions<ITradeHistoryResponse>) => {
    const queryParams = new URLSearchParams();
    queryParams.set("page", `${page}`);
    queryParams.set("pageSize", `${PAGE_SIZE}`);
    return useQuery<ITradeHistoryResponse>({
        url: createApiWikifolioTradeHistoryUrl(wikifolioId),
        queryKey: tradeKeys.history(wikifolioId, page),
        retry: 0,
        placeholderData: keepPreviousData,
        queryParams,
        ...options,
    });
};
